import { deleteHub } from '@/backend/hubs'
import type { Eventually } from '@/data/clientUtils'
import { useHubStore } from '@/data/Hubs/useHubStore'
import { queryClient } from '@/modules/App/queryClient'
import { invariant } from '@/shared/utils/typeAssertions'
import { useMutation } from '@tanstack/vue-query'
import { toValue } from 'vue'

/**
 * Mutation for deleting a hub
 */
export function useDeleteHubMutation(props: { workspaceId: Eventually<string> }) {
  const hubStore = useHubStore()

  return useMutation({
    mutationFn: async (hubId: string) => {
      const workspaceId = toValue(props.workspaceId)
      invariant(workspaceId)
      const response = await deleteHub(workspaceId, hubId)
      if (!response.ok) throw new Error(response.error.message)
    },
    onMutate(id) {
      hubStore.hubs.delete(id)
    },
    onError() {
      return queryClient.invalidateQueries({ queryKey: [props.workspaceId, 'hubs'] })
    },
  })
}
